import React, { useEffect, useState } from "react";
import { FaTwitterSquare, FaFacebookSquare } from "react-icons/fa";
import { useCookies } from "react-cookie";
import JSshare  from "../Tabs/JSshare";
import "../../black-box/custom.css";
import styles from "./index.module.css";
// import { LoadingOverlay, Loader } from "react-overlay-loader";
import { Box, Card, CardContent, Typography } from "@material-ui/core";

const LMRequestForQuotePage = props => {
    const [getWishlist, setWishlist] = useState([]);
    const [cookies, setCookie, removeCookie] = useCookies("gemfind_sessionId");
    const [loaded, setLoaded] = useState(false);
    const [loadApi, setloadApi] = useState(true);

    var url_string = window.location; 
    var url = new URL(url_string);
    var wid = '';
    // atob('MjIy')
    if(url.searchParams.get("wid")){
        wid = atob(url.searchParams.get("wid"))
    }
    
    const getQuotedProductCount = async () => {
        setLoaded(true);
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                session_id: cookies.gemfind_sessionId,
                product_id: "",
                handle: props.props,
                saveforlater: "false",
                customer_id:
                wid == '' ? 
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null : wid    
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "myWishlist",
            requestOptions
        );
        const set_count = await res.json();
        console.log(set_count);
        setWishlist(set_count.data.wishlist_status);
        setLoaded(false);
    };

    useEffect(() => {
        if (loadApi === true) {
            getQuotedProductCount();
            setloadApi(false);
        }
    }, [loadApi, getWishlist]);

    useEffect(()=>{
        if(loaded){
            document.querySelector(".gf--loader--body").style="display:block;";
        }else{
            document.querySelector(".gf--loader--body").style="display:none;";
        }
    },[loaded]);
    return (
        <>
            {getWishlist.length > 0 ? (
                <div>
                    <style>
                        {`
                    .react-overlay-loader-spinner {
                        background-image: url(${process.env.REACT_APP_IMAGE_URL}"images/heart_loader.gif");
                    }
                `}
                    </style>
                    {/* <LoadingOverlay className="_loading_overlay_wrapper">
                        <Loader fullPage loading={loaded} />
                    </LoadingOverlay> */}

                    <div>
                        <JSshare/>
                    </div>

                    <div className={styles.gemgridrow}>
                        <div className={styles.gridcontainer}>
                            {getWishlist.map(item => (
                                <div className={styles.gridbox}>
                                    <div className={styles.productimg}>
                                        <img src={item.image} alt="watch" />
                                    </div>
                                    <div className={styles.productinfo}>
                                        <h2 className={styles.Product_title}>
                                            {item.title}
                                        </h2>
                                        <h3 className={styles.Product_price}>
                                            ${item.price}
                                        </h3>
                                        {item.stock_status != "In Stock" ? (
                                            <span
                                                className={
                                                    styles.Productstock +
                                                    " " +
                                                    styles.outofstock
                                                }
                                            >
                                                out of stock
                                            </span>
                                        ) : (
                                            <span
                                                className={
                                                    styles.Productstock +
                                                    " " +
                                                    styles.instock
                                                }
                                            >
                                                instock
                                            </span>
                                        )}
                                        <div className={styles.addtocartbtn}>
                                            <a href={item.addtocart_link}>
                                                Add To Cart
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <style>
                        {`
                    .react-overlay-loader-spinner {
                        background-image: url(${process.env.REACT_APP_IMAGE_URL}"images/heart_loader.gif");
                    }
                `}
                    </style>
                    {/* <LoadingOverlay className="_loading_overlay_wrapper">
                        <Loader fullPage loading={loaded} />
                    </LoadingOverlay> */}

                    <div>
                    <JSshare/>
                    </div>

                    <div className={styles.gemgridrow}>
                        <div className={styles.gridcontainer}>
                            My Wishlist Page is empty!!
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
export default LMRequestForQuotePage;
